import { render, staticRenderFns } from "./s-cover.vue?vue&type=template&id=0338b4da&scoped=true&"
import script from "./s-cover.vue?vue&type=script&lang=js&"
export * from "./s-cover.vue?vue&type=script&lang=js&"
import style0 from "./s-cover.vue?vue&type=style&index=0&id=0338b4da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0338b4da",
  null
  
)

export default component.exports